import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const InputWrapper = styled.div`
  display: grid;
  gap: 6px;
`;

export const Container = styled.div<ContainerProps>`
  background: #fff;
  border-radius: 6px;
  position: relative;
  padding: 12px 16px;
  width: 100%;

  border: 1px solid #e0e0e0;
  color: #828282;

  display: flex;
  align-items: center;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #4f4f4f;
      border-color: ${props.theme.colors.primary};
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #4f4f4f;
    `}



  input {
    flex: 1;
    border: 0;
    background: transparent;
    color: #000;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 14px;
    width: 100%;

    &:focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }

    &::placeholder {
      color: #828282;
    }
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;

export const InputLabel = styled.strong`
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`;
